// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"q2-z","colorTextValue":"r2-z","swatches":"s2-z","collapseLink":"t2-z","isCollapsed":"u2-z","dropdown":"v2-z","disabled":"w2-z"};